import { useEffect, useState } from 'react';
import Loading from '~~elements/Loading';
import toast from '~~elements/Toast';
import { UserResource } from '~~apis/resource';
import Multilingual from '~~utils/Multilingual';
import MyPluginOrder from './MyPluginOrder';

const Index = (props) => {
  const [loading, setLoading] = useState(true);
  const [pluginOrders, setPluginOrders] = useState([]);

  useEffect(() => {
    setLoading(true);
    UserResource.pluginOrderList()
      .then(({ data }) => {
        setPluginOrders(data);
      })
      .catch((e) => {
        toast(Multilingual(`UNKNOWN_ERROR`), { status: 'error', second: 2 });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <Loading margin="3rem auto" />;
  }

  return <MyPluginOrder {...props} pluginOrders={pluginOrders} />;
};

export default Index;
